import { render, staticRenderFns } from "./AdminAddRole.vue?vue&type=template&id=1d64e12c&scoped=true&"
import script from "./AdminAddRole.vue?vue&type=script&lang=js&"
export * from "./AdminAddRole.vue?vue&type=script&lang=js&"
import style0 from "./AdminAddRole.vue?vue&type=style&index=0&id=1d64e12c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d64e12c",
  null
  
)

export default component.exports